function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Streaming-Delivery_hover",
  transform: "translate(-636.000000, -132.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-34",
  transform: "translate(636.000000, 132.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#7E57C2",
  cx: 24,
  cy: 24,
  r: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_CPM_1179448",
  transform: "translate(13.000000, 16.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.9625,8.51764706 C13.8239583,8.51764706 11.0447917,10.5882353 11.0447917,12.2352941 C11.0447917,13.9058824 13.7760417,15.9529412 16.9625,15.9529412 C20.2447917,15.9529412 22.8802083,13.9294118 22.8802083,12.2352941 C22.8802083,10.5882353 20.1010417,8.51764706 16.9625,8.51764706 Z M16.9625,15.0352941 C14.0635417,15.0352941 11.9552083,13.1764706 11.9552083,12.2117647 C11.9552083,11.2705882 14.1114583,9.38823529 16.9625,9.38823529 C19.8135417,9.38823529 21.9697917,11.2705882 21.9697917,12.2117647 C21.9697917,13.3176471 19.7177083,15.0352941 16.9625,15.0352941 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.9625,10.5411765 C16.028125,10.5411765 15.2614583,11.2941176 15.2614583,12.2117647 C15.2614583,13.1294118 16.028125,13.8823529 16.9625,13.8823529 C17.896875,13.8823529 18.6635417,13.1294118 18.6635417,12.2117647 C18.6875,11.2941176 17.9208333,10.5411765 16.9625,10.5411765 Z M16.9625,13.0117647 C16.53125,13.0117647 16.171875,12.6588235 16.171875,12.2352941 C16.171875,11.8117647 16.53125,11.4588235 16.9625,11.4588235 C17.39375,11.4588235 17.753125,11.8117647 17.753125,12.2352941 C17.7770833,12.6588235 17.4177083,13.0117647 16.9625,13.0117647 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.96666667,13.3647059 L1.509375,13.3647059 C1.24583333,13.3647059 1.03020833,13.1529412 1.03020833,12.8941176 L1.03020833,1.43529412 C1.03020833,1.17647059 1.24583333,0.964705882 1.509375,0.964705882 L18.4239583,0.964705882 C18.6875,0.964705882 18.903125,1.17647059 18.903125,1.43529412 L18.903125,7.31764706 C18.903125,7.55294118 19.11875,7.76470588 19.3583333,7.76470588 C19.5979167,7.76470588 19.8135417,7.55294118 19.8135417,7.31764706 L19.8135417,1.43529412 C19.8135417,0.682352941 19.190625,0.0705882353 18.4239583,0.0705882353 L1.509375,0.0705882353 C0.742708333,0.0705882353 0.119791667,0.682352941 0.119791667,1.43529412 L0.119791667,12.8705882 C0.119791667,13.6235294 0.742708333,14.2352941 1.509375,14.2352941 L9.96666667,14.2352941 C10.20625,14.2352941 10.421875,14.0235294 10.421875,13.7882353 C10.421875,13.5529412 10.2302083,13.3647059 9.96666667,13.3647059 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2979167,4.44705882 L2.61145833,4.44705882 C2.371875,4.44705882 2.15625,4.65882353 2.15625,4.89411765 C2.15625,5.12941176 2.371875,5.34117647 2.61145833,5.34117647 L17.2979167,5.34117647 C17.5375,5.34117647 17.753125,5.12941176 17.753125,4.89411765 C17.753125,4.65882353 17.5614583,4.44705882 17.2979167,4.44705882 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.753125,6.89411765 C17.753125,6.65882353 17.5375,6.44705882 17.2979167,6.44705882 L2.61145833,6.44705882 C2.371875,6.44705882 2.15625,6.65882353 2.15625,6.89411765 C2.15625,7.12941176 2.371875,7.34117647 2.61145833,7.34117647 L17.2979167,7.34117647 C17.5614583,7.34117647 17.753125,7.12941176 17.753125,6.89411765 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1708333,8.89411765 C12.1708333,8.65882353 11.9552083,8.44705882 11.715625,8.44705882 L2.61145833,8.44705882 C2.371875,8.44705882 2.15625,8.65882353 2.15625,8.89411765 C2.15625,9.12941176 2.371875,9.34117647 2.61145833,9.34117647 L11.715625,9.34117647 C11.9791667,9.34117647 12.1708333,9.12941176 12.1708333,8.89411765 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.61145833,10.4470588 C2.371875,10.4470588 2.15625,10.6588235 2.15625,10.8941176 C2.15625,11.1294118 2.371875,11.3411765 2.61145833,11.3411765 L9.703125,11.3411765 C9.94270833,11.3411765 10.1583333,11.1294118 10.1583333,10.8941176 C10.1583333,10.6588235 9.94270833,10.4470588 9.703125,10.4470588 C9.703125,10.4470588 2.61145833,10.4470588 2.61145833,10.4470588 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.61145833,3.17647059 C3.35416667,3.17647059 3.35416667,2.04705882 2.61145833,2.04705882 C1.89270833,2.04705882 1.89270833,3.17647059 2.61145833,3.17647059 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.28854167,2.04705882 C3.54583333,2.04705882 3.54583333,3.17647059 4.28854167,3.17647059 C5.03125,3.17647059 5.03125,2.04705882 4.28854167,2.04705882 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.94166667,2.04705882 C5.19895833,2.04705882 5.19895833,3.17647059 5.94166667,3.17647059 C6.684375,3.17647059 6.684375,2.04705882 5.94166667,2.04705882 Z",
  id: "Path"
}))))));
function SvgECpm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECpm);
export default __webpack_public_path__ + "static/media/eCPM.7abf9dedc356546a653a2f0072edd2a9.svg";
export { ForwardRef as ReactComponent };